import { withStyles } from '@material-ui/core';
import styles from './HeaderWithYearPicker.styles';
import HeaderWithYearPicker from './HeaderWithYearPicker';

export default withStyles(styles)(HeaderWithYearPicker);
